/*** This function will count the number of type and remaing character in textarea ***/
function textCounter(field) {
  var complimentaryText = jQuery(field).val()
  var variantId = jQuery(field).attr("data-variantid")
  var _associated_unique_key = jQuery(field).attr("data-unique-key")
  jQuery('#complimentarywrapTextarea' + variantId+_associated_unique_key).html(complimentaryText)
  var maxlimit = jQuery(field).attr("maxlength")
  if (field.value.length > maxlimit) {
    field.value = field.value.substring(0, maxlimit);
    return false;
  } else {
    var typedChar = maxlimit - field.value.length;
    jQuery(field).next().find("span").text(typedChar)
  }
}

$('#complimentarywrapCheckbox').on('click', function () {
  if (!$('#complimentarywrapCheckbox').is(':checked')) jQuery('.errormsg').text('').removeClass('open').addClass('hide')
});

/* Enabling the Complientary, Gift Wrap & Text Boxes */
window.addEventListener('DOMContentLoaded', (event) => {
  setTimeout(function() {
    $("[id*='giftwrapTextarea'], [id*='complimentarywrapTextarea']").prop("disabled", false);
    $(".QuantitySelector__Button, .CartItem__Remove").removeClass("disabled");
  }, 1500);
});

/* Fetching cart data */
function fetchCartDataLoyalty(callback) {
  $.ajax({
    url: '/cart.js',
    method: 'GET',
    dataType: 'json',
    success: function(cart) {
      callback(cart);
    },
    error: function() {
      console.error('Failed to fetch cart data.');
      callback(null);
    }
  });
}

/* ========= Loyalty Lion Credit Points Integration on Cart Page ========= */
/* Append loyalty points based on the final price */
function appendLoyaltyPoints(grabFinalPrice) {
  var email = loggedInCustomerEmail;
  if (email) {
    var settings = {
      url: "https://shopifyapi.ringconcierge.com/loyalty-lion-email-search",
      method: "POST",
      timeout: 0,
      headers: {
        "Content-Type": "application/json"
      },
      data: JSON.stringify({ email: email })
    };
    $.ajax(settings).done(function(response) {
      var customer = response.data.customers[0];
      var loyaltyTier = customer.loyalty_tier_membership.loyalty_tier.number;
      var mainElementClass = $('.gettingPointCartPage');
      var points = parseFloat(grabFinalPrice);
      if (!isNaN(points)) {
        // Fetch findingpoints and calculate dollars
        dynamicLoyaltyTiersSectionData(function(findingpoints) { 
          // Ensure findingpoints is a valid number
          var dollarConversionRates = parseFloat(findingpoints) / 100;
          if (!isNaN(dollarConversionRates)) {
            var dollars = (points / 100 * dollarConversionRates).toFixed(2);
            dollars = addCommas(dollars);
            mainElementClass.text('$' + dollars);
            $('.loyalty-account-point').removeClass('hide');
          }
        });
      }
    });
  }
}

/* Fetch Dynamic Loyalty Tiers Section Data */
function dynamicLoyaltyTiersSectionData(callback) {
  var intervalId = setInterval(function() {
    var findingpoints = $(".loyalty-ways-earn-point-section")
    .find(".lion-rules-list ").find(".lion-rule-item--purchase").find(".lion-rule-item__points").find(".value").html();
    if (findingpoints) {
      clearInterval(intervalId); 
      callback(findingpoints); 
    }
  }, 200);
}

/* Helper function to format numbers with commas */
function addCommas(number) {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

/* Process data and calculate subtotal excluding products with a specific tag and applying double/triple points */
function integrateLoyaltyCreditPoints() {
  fetchCartDataLoyalty(function(cart) {
    if (cart) {
      var exclueProductTag = 'll-exclusion';
      var totalExcludingSpecificTag = 0;
      var pendingRequests = cart.items.length;
      cart.items.forEach(function(item) {
        var llExclusionTagFound = $("#"+item.variant_id+"-"+item.product_id).attr('data-ll-exclusion-tag');
        var llExclusionDoublePoint = $("#"+item.variant_id+"-"+item.product_id).attr('data-ll-double-point');
        var llExclusionTriplePoint = $("#"+item.variant_id+"-"+item.product_id).attr('data-ll-triple-point');
        if (llExclusionTagFound && llExclusionTagFound !== 'true') {
          var itemTotalPrice = item.final_price * item.quantity;
          // Check for double or triple points tags
          if (llExclusionDoublePoint && llExclusionDoublePoint === 'true') {
            itemTotalPrice *= 2;  // Apply 2x points
          } else if (llExclusionTriplePoint && llExclusionTriplePoint === 'true') {
            itemTotalPrice *= 3;  // Apply 3x points
          }
          totalExcludingSpecificTag += itemTotalPrice;
        }
        pendingRequests--;
        if (pendingRequests === 0) {
          appendLoyaltyPoints(totalExcludingSpecificTag);
        }
      });
    }
  });
}
/********* Save Focus on Any Focusable Element *********/
// Save focus ID when elements with [data-focus-id] are focused or clicked
$(document).on("focusin click", "[data-focus-id]", function () {
  const idToSave = this.type === 'checkbox' ? this.id : this.dataset.focusId;
  localStorage.setItem("savedFocusId", idToSave);
});
// Restore focus on load
$(function () {
  const savedFocusId = localStorage.getItem("savedFocusId");
  if (savedFocusId) {
    setTimeout(() => {
      let $focusedItem = $(`[data-focus-id='${savedFocusId}']`);
      // If not found by data-focus-id, try by ID
      if (!$focusedItem.length) {
        $focusedItem = $(`#${savedFocusId}`);
      }
      if ($focusedItem.length) {
        $focusedItem.addClass("suppress-outline");
        $focusedItem.trigger("focus");
        // Re-enable outline once user presses Tab
        $(document).on("keydown.outline", function (e) {
          if (e.key === "Tab") {
            $(".suppress-outline").removeClass("suppress-outline");
            $(document).off("keydown.outline");
          }
        });
        localStorage.removeItem("savedFocusId");
      }
    }, 500);
  }
});

$("body").on('click', function(){
  $("body").attr("style","overflow: visible;")
})

function removeScroll(){
  setTimeout(function() {
    $("body").removeClass("no-scroll")
  }, 50);
}

function startScroll(){
  setTimeout(function() {
    $("body").addClass("no-scroll")
    $("body").removeAttr("style")
  }, 50);
}

/* Managing Delays between functions because of Shopify API call limits */
function delay(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

/*** Handling the input change ***/
function updateGiftWrapItemsByInput(e, action) {
  var grabUniqueKey = $(e).attr("data-associate-unique-key");
  var quantity = parseInt($(e).attr("data-quantity"), 10);
  // Proceed only when a valid unique key is found
  if (grabUniqueKey) {
    updateGiftWrapItems(grabUniqueKey, quantity, action, e);
  }
}

/*** Remove CTA, Quantity Increase, and Decrease ***/
function updateVariantWithGhostProducts(e, action) {
  if ($(e).hasClass("disabled")) return;
  var grabUniqueKey = $(e).attr("data-associate-unique-key");
  var quantity = parseInt($(e).attr("data-quantity"), 10);
  // Proceed only when a valid unique key is found
  if (grabUniqueKey) {
    updateGiftWrapItems(grabUniqueKey, quantity, action);
  }
}

/*** Update product + associated items or remove them selectively ***/
async function updateGiftWrapItems(grabUniqueKey, quantity, action, e) {
  $(".siteLoader").show();
  try {
    // Fetch the latest cart state
    const response = await fetch("/cart.js");
    const cartData = await response.json();
    const updates = {}; // Create an update object
    // Find all matching cart items by the unique key
    cartData.items.forEach(item => {
      if ( item.properties && item.properties._associated_unique_key === grabUniqueKey) {
        if (action === "manage_quantity") {
          updates[item.key] = quantity; // Set new quantity
        } else if (action === "remove_items") {
          updates[item.key] = 0; // Remove item by setting quantity to 0
        }
      }
    });
    // Perform cart update if there are any changes
    if (Object.keys(updates).length > 0) {
      //console.log("Executing bulk update with items:", updates);
      await bulkUpdateItemsWithRetry(updates, action, e);
    }
  } catch (error) {
    console.error("Error during updateGiftWrapItems:", error);
    window.location.reload();
  } finally {
    $(".siteLoader").hide();
  }
}

/*** Retry Logic for Bulk Updates with Page Reload on Success ***/
async function bulkUpdateItemsWithRetry(updates, action, e) {
  const retryCount = 3;
  for (let attempt = 1; attempt <= retryCount; attempt++) {
    try {
      await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ updates: updates })
      });
      // Check if any key from `updates` exists in the cart
      if(action === "remove_items"){      
        const updatedCartResponse = await fetch("/cart.js");
        const updatedCart = await updatedCartResponse.json();
        // Get all line item keys currently in cart
        const cartLineKeys = updatedCart.items.map(item => item.key);
        for (const key of Object.keys(updates)) {
          if (cartLineKeys.includes(key)) {
            //console.log(`🔑 Key found in cart: ${key}, Executing Function Again...`);
            await updateVariantWithGhostProducts(e, action);
            break;
          } else {
            console.log(`🔑 Key NOT found in cart: ${key}`);
          }
        }
      }
      window.location.reload(); // Reload the page on success
      break;
    } catch (error) {
      console.error(`Error updating cart (attempt ${attempt}):`, error);
      if (attempt === retryCount) {
        console.log("Failed to update cart after multiple attempts. Please try again.");
        window.location.reload();
      }
    }
  }
}

/* ============= Wedding Band Purchase functionality integration ================== */
function weddingBandPurchase(element) {
  $(".siteLoader").show();
  var variantId = $(element).data('variant-id');
  var variantUniqueKey = $(element).data('unique-key');
  // Finding the line item in the cart matching the product ID
  var existingItem = fetchCartData.items.find(function (item) {
    return item.variant_id == variantId;
  });
  // Combine existing properties with new properties
  var mergedProperties = {};
  if (existingItem && existingItem.properties) {
    mergedProperties = Object.assign({}, existingItem.properties);
  }
  // Add or Remove property along with the existing properties
  if (mergedProperties && mergedProperties['_wedding_band_purchase']){
    if (!$('#giftwrapCheckbox'+variantId+variantUniqueKey).is(':checked')) {
      delete mergedProperties['_giftwrap']
    }
    delete mergedProperties['_wedding_band_purchase']
  } else {
    mergedProperties['_wedding_band_purchase'] = true;
    mergedProperties['_giftwrap'] = true;
  }
  // Update the line item in the cart
  $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    dataType: 'json',
    data: {
      id: existingItem.key,
      quantity: parseInt(existingItem.quantity),
      properties: mergedProperties
    },
    success: function (response) {
      $(".siteLoader").hide();
      window.location.reload();
    },
    error: function (xhr, status, error) {
      console.error('Error updating product properties in cart:', error);
      window.location.reload();
    }
  });
}

function updateinputval(e) {
  var dataQuantity = 1
  var val = jQuery(e).val().trim()
  var lineid = jQuery(e).attr("data-line-id")
  var variantId = jQuery(e).attr("data-variant-id")
  var lineidIndex = jQuery(e).attr("data-line-index")
  var lineidkey = jQuery(e).attr("data-line-key")
  var lineTextKey = jQuery(e).attr("data-text-key")
  var _associated_unique_key = jQuery(e).attr("data-unique-key")
  var required = jQuery('#Customization_Required' + variantId).text()
  dataQuantity = jQuery(e).attr("data-quantity")

  jQuery('.Cart__Checkout').removeAttr('disabled')

  if (jQuery('#Customization' + variantId+_associated_unique_key).length) {
    jQuery('#Customization' + variantId+_associated_unique_key).removeClass('required')
  }
  if (jQuery('#' + lineTextKey + variantId).length) {
    jQuery('#' + lineTextKey + variantId).removeClass('required')
  }
  var formAction = true
  if (lineidkey === 'Customization' && required === 'Yes' && val.length === 0) {
    jQuery('.Cart__Checkout').attr('disabled', 'disabled')
    jQuery('#Customization' + variantId+_associated_unique_key).addClass('required')
    jQuery(e).val('')
    formAction = false
  } else if (lineTextKey && lineTextKey.replace(/ /g, '').indexOf('HeartText') !== -1 && val.length === 0) {
    jQuery('.Cart__Checkout').attr('disabled', 'disabled')
    jQuery('#' + lineTextKey + variantId).addClass('required')
    formAction = false
  } else if (lineTextKey && lineTextKey.replace(/ /g, '').indexOf('Name') !== -1 && val.length === 0) {
    jQuery('.Cart__Checkout').attr('disabled', 'disabled')
    jQuery('#' + lineTextKey + variantId).addClass('required')
    formAction = false
  } else if (lineTextKey && lineTextKey.replace(/ /g, '').indexOf('MiniHeart') !== -1 && val.length === 0) {
    jQuery('.Cart__Checkout').attr('disabled', 'disabled')
    jQuery('#' + lineTextKey + variantId).addClass('required')
    formAction = false
  } else {
    jQuery('.Cart__Checkout').removeAttr('disabled')
  }

  if (formAction) {
    $(".siteLoader").show()
    fetch("/cart.js")
      .then(response => response.json())
      .then(cartData => {
        if (cartData && cartData.items && cartData.items.length > 0) {
          var props = {}
          cartData.items.map(function (item, i) {
            if (item.properties && item.id == parseInt(lineid) && item.properties['_associated_unique_key'] == _associated_unique_key) {
              props = item.properties
            }
          })
          return props
        }
      })
      .then(function (props) {
        if (lineid) {
          var dataToSend = { id: lineid, quantity: dataQuantity, properties: props }
          dataToSend['properties'][`${lineidkey}`] = val
          fetch('/cart/change.js', {
            body: JSON.stringify(dataToSend),
            credentials: 'same-origin',
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            }
          })
          .then(response => response.json())
          .then(function (cart) {
            return cart
          })
        }
      }).then(function (cart) {
        return fetch("/cart.js")
          .then(response => response.json())
          .then(cartData => {
            window.location.reload()
          })
      }).catch(function (error) {
        window.location.reload()
      })
   }
}

/* Restrict users to Enter Emojis */
function checkForEmojis(textarea) {
  var variantId = jQuery(textarea).attr("data-variantid");
  var uniqueID = jQuery(textarea).attr("data-unique-key");
  $(".gift-wrap-count-"+variantId+uniqueID).text((jQuery(textarea).attr("maxlength") - jQuery(textarea)?.val().length)+'/'+jQuery(textarea).attr("maxlength"))
  textarea.value = textarea.value.replace(/✌️|❤️/g, '');
  var regex = /[\uD800-\uDBFF][\uDC00-\uDFFF]|\p{Emoji_Presentation}/gu;
  var text = textarea.value;
  if (regex.test(text)) {
    var cleanedText = text.replace(regex, '');
    textarea.value = cleanedText;
  }
}

/* ========= UPDATING LEAD TIME ON CART PAGE =========*/
async function updateLeadTimeOnCartPage(cart) {
  if (!cart?.items?.length) return;

  const variantCountMap = {};
  const leadTimeCache = new Map();
  const itemsToUpdate = [];

  const shouldSkipItem = (item) => {
    return (
      item.properties?._sccl_associated_variant_id ||
      item.properties?._complimentary_associated_variant_id ||
      item.properties?._stone_associated_variant_id ||
      item.properties?._associated_variant_id ||
      item.properties?.DiamondId ||
      item.properties?._associated_link_variant_id !== undefined ||
      item.product_id == 7374146306136 ||
      item.product_id == 8267633524824 ||
      item.product_id == 8812814860376 ||
      item.product_type === 'Bundle Sets'
    );
  };

  const fetchLeadTime = async (item, unit) => {
    const key = `${item.product_id}_${item.variant_id}_${unit}`;
    if (leadTimeCache.has(key)) return leadTimeCache.get(key);

    const p = fetch(
      `${cartApiUrl}/mongo/leadtimes?shopifyProductId=${item.product_id}&variantId=${item.variant_id}&unit=${unit}`,
      { headers: { 'Content-Type': 'application/json' } }
    ).then(r => r.json()).catch(() => null);

    leadTimeCache.set(key, p);
    return p;
  };

  function getLeadTimeFromDOM(item) {
    const uniqueKey = item.variant_id + "_" + item.properties._associated_unique_key;
    const $li = $(
      `.CartItem__PropertyList[data-unique-key="${uniqueKey}"] 
      li[data-propertyfirst="Custom Lead Time"]`
    );
    return $li.length ? $li.data('propertylast') : '';
  }

  /* ========= STEP 1: GRAB LEAD TIMES ========= */
  await Promise.all(cart.items.map(async (item) => {
    item.properties = item.properties || {};
    variantCountMap[item.variant_id] =
      (variantCountMap[item.variant_id] || 0) + item.quantity;

    if (shouldSkipItem(item)) return;

    let updatedLeadTime = '';
    let customLeadTime = getLeadTimeFromDOM(item);

    try {
      const res = await fetchLeadTime(item, variantCountMap[item.variant_id]);
      const qty = res?.data?.availableToSell;
      
      if (qty <= 0 || !res?.data?.inventory_management) {
        updatedLeadTime = customLeadTime || '';
      } else if (qty > 30) {
        updatedLeadTime = 'In Stock';
      } else if (qty > 0) {
        updatedLeadTime = 'Only a few left!';
      }
    } catch (error) {
      console.error('Error updating Lead Time', error);
    }

    if (
      !updatedLeadTime ||
      updatedLeadTime.trim() === item.properties['Lead Time']?.trim() ||
      item.properties?._is_bespoke_product === 'true'
    ) return;

    item.properties['Lead Time'] = updatedLeadTime;

    if (!item.properties['_associated_unique_key']) {
      item.properties['_associated_unique_key'] =
        (Math.random() + 1).toString(36).substring(2);
    }
    itemsToUpdate.push(item);
  }));

  if (!itemsToUpdate.length) return;

  /* ========= STEP 2: UPDATE LEAD TIMES ON UI ========= */
  itemsToUpdate.forEach(item => {
    const uniqueKey = item.variant_id + "_" + item.properties._associated_unique_key;

    waitForCartItemWrapper(item.product_id, ($parent) => {
      let $propertyList = $parent.find(
        ".CartItem__PropertyList[data-unique-key='" + uniqueKey + "']"
      );
      /* === Create UL if missing === */
      if (!$propertyList.length) {
        $propertyList = $("<ul>", {
          class: "CartItem__PropertyList",
          "data-unique-key": uniqueKey,
          "data-variantid": item.variant_id,
          "data-quantity": item.quantity,
          "data-varianttitle": item.variant_title,
          "data-sku": item.sku
        });
        $parent.find(".CartItem__Meta .CartItem__Variant").after($propertyList);
      }

      let $li = $propertyList.find("li[data-propertyfirst='Lead Time']");
      if (item.properties["Lead Time"]?.trim()) {
        if (!$li.length) {
          $li = $("<li>", {
            class: "CartItem__Property",
            "data-variantid": item.variant_id,
            "data-propertyfirst": "Lead Time",
            "data-propertylast": item.properties["Lead Time"],
            text: item.properties["Lead Time"]
          });
          $propertyList.append($li);
        } else {
          $li.attr("data-propertylast", item.properties["Lead Time"]).text(item.properties["Lead Time"]);
        }
      } else if ($li.length) {
        $li.remove();
      }
    });
  });

  /* ========= STEP 3: UPDATING LEAD TIME TO LINE ITEM PROPERTY ========= */
  await updateLineItemsSequentially(itemsToUpdate);

  if (formActionGift && formActionCom) {
    setTimeout(() => {
      jQuery('.Cart__Checkout').removeAttr('disabled');
    }, 300);
  }
}

/* ========= UPDATING LINE ITEM PROPERTY ========= */
async function updateLineItemsSequentially(items) {
  try {
    for (const item of items) {
      if (item.properties?._giftwrap) {
        item.properties['_giftwrap'] = "true";
      }
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: item.key,
          quantity: item.quantity,
          properties: item.properties
        })
      });
      const cart = await response.json();
      /* ========= Re-sync remove button attribute after cart mutation ========= */
      syncRemoveButton(cart, item);
    }
  } catch (error) {
    console.error('Error updating Line Item Property', error);
  }
}

/* ========= Updating data key attribute for Remove CTA ========= */
function syncRemoveButton(cart, item) {
  if (!cart?.items?.length) return;
  const updatedItem = cart.items.find(ci =>
    String(ci.variant_id) === String(item.variant_id) &&
    ci.properties?._associated_unique_key ===
      item.properties._associated_unique_key
  );
  if (!updatedItem) return;
  // Find the correct CartItemWrapper FIRST
  waitForCartItemWrapper(item.product_id, ($parent) => { 
    const $removeBtn = $parent.find(".CartItem__Remove"); // Find remove button ONLY inside this wrapper
    if (!$removeBtn.length) return;
    const uniqueKey = item.variant_id + "_" + item.properties._associated_unique_key;
    $removeBtn.attr("data-key", updatedItem.key).attr("data-unique-key", uniqueKey); // Update attributes
  });
}

/* ========= Finding correct item through parent class  ========= */
function waitForCartItemWrapper(productId, cb, timeout = 2000) {
  productId = String(productId);
  const tryFind = () => {
    const $el = $(".CartItemWrapper").filter(function () {
      return String($(this).attr("data-tagg-rootid")).trim() === productId;
    });
    if ($el.length) return $el;
    return null;
  };
  const found = tryFind();
  if (found) return cb(found);

  const observer = new MutationObserver(() => {
    const el = tryFind();
    if (el) {
      observer.disconnect();
      cb(el);
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
  setTimeout(() => observer.disconnect(), timeout);
}

/* ===== Appending Sale price on cart page ===== */
$(document).ready(async function () {
  integrateCartSalePrice();
})

async function integrateCartSalePrice() {
  var fetchFreshCartData = await fetch("/cart.js");
  const cartData = await fetchFreshCartData.json();
  if(cartData && cartData.items.length) {
    var totalSavings = 0; // initialize total savings tracker
    for (var i = 0; i < cart.items.length; i++) {
      var data = cart.items[i];
      if(data.properties._engraving_required && data.properties._engraving_required === 'Yes'){
        $(".append-engraving-text-" + data.variant_id + data.properties._associated_unique_key).append('<h6 class="engravingAddProductLabel GiftWrapLabel"><span>Add Engraving </span>$'+ engravingProductPrice +'</h6>');
        if($(window).width() <= 640){
          $(".CartItem__Price_"+ data.variant_id + '_' + data.properties._associated_unique_key).append('<h6 class="engravingAddProductLabel GiftWrapLabel append-mobile-engrave-text"><span>Added Engraving </span>$'+ engravingProductPrice + '</h6>');
        }
      }
      if (!data.properties?._sccl_associated_variant_id && !data.properties?._complimentary_associated_variant_id && !data.properties?._stone_associated_variant_id && !data.properties?._associated_variant_id && !data.properties?.DiamondId) {
        var quantity = $(".grab_quantity" + data.variant_id+ data.properties._associated_unique_key).attr("data-quantity");
        var regPrice = parseFloat(data.price / 100);
        var vipPrice = $(".bcpo-cart-item-line-price" + data.variant_id + data.properties._associated_unique_key).eq(1).attr("data-variant-vip-price") ? parseFloat($(".bcpo-cart-item-line-price" + data.variant_id + data.properties._associated_unique_key).eq(1).attr("data-variant-vip-price")) : 0;
        var vvipPrice = $(".bcpo-cart-item-line-price" + data.variant_id + data.properties._associated_unique_key).eq(1).attr("data-variant-vvip-price") ? parseFloat($(".bcpo-cart-item-line-price" + data.variant_id + data.properties._associated_unique_key).eq(1).attr("data-variant-vvip-price")) : 0;
        var checkVisitingCustomer = localStorage.getItem("setVisitingCustomer");
        var checkVisitingCustomerPrivateSale = localStorage.getItem("setVisitingCustomerPrivateSale");
        var salePrice = 0;
        var compareAtPrice = parseFloat($(".bcpo-cart-item-line-price" + data.variant_id + data.properties._associated_unique_key).eq(1).attr("data-variant-compare-at"))/100;
        var showPercentOff = false
        var enableCompareAtPrice= false;
  
        /* Sale Price for All Visitors */
        if (showSalePriceGlobal && showSalePriceGlobal === true) {
          salePrice = $(".bcpo-cart-item-line-price" + data.variant_id + data.properties._associated_unique_key).eq(1).attr("data-variant-sale-price") ? parseFloat($(".bcpo-cart-item-line-price" + data.variant_id + data.properties._associated_unique_key).eq(1).attr("data-variant-sale-price")) : 0;
          showPercentOff = true
          enableCompareAtPrice= true;
        }
        /* Sale Price to show for VIP Visitors */
        if (showVIPPriceGlobal && showVIPPriceGlobal === true && checkVisitingCustomer && checkVisitingCustomer == getVIPParam) {
          salePrice = vipPrice;
          showPercentOff = true;
          enableCompareAtPrice= true;
        }
        /* Sale Price to show for VVIP Visitors */
        if (showVVIPPriceGlobal && showVVIPPriceGlobal === true && checkVisitingCustomer && checkVisitingCustomer == getVVIPParam) {
          salePrice = vvipPrice;
          showPercentOff = true;
          enableCompareAtPrice= true;
        }
        /* Locked Private Sale: Sale Price to show for VIP Visitors */
        if (showVIPPrivateSale && showVIPPrivateSale === true && checkVIPUser && checkVIPUser === true && checkVisitingCustomerPrivateSale && checkVisitingCustomerPrivateSale == getVIPParamPrivateSale) {
          salePrice = vipPrice;
          showPercentOff = true;
          enableCompareAtPrice= true;
        }
        /* Locked Private Sale: Sale Price to show for VVIP Visitors */
        if (showVVIPPrivateSale && showVVIPPrivateSale === true && checkVVIPUser && checkVVIPUser === true && checkVisitingCustomerPrivateSale && checkVisitingCustomerPrivateSale == getVVIPParamPrivateSale) {
          salePrice = vvipPrice;
          showPercentOff = true;
          enableCompareAtPrice= true;
        }

        /* ===== Fold associated charm prices into this main item ===== */
        var activeTier = '';
        if (showSalePriceGlobal === true) activeTier = 'sale';
        if (showVIPPriceGlobal === true && checkVisitingCustomer == getVIPParam) activeTier = 'vip';
        if (showVVIPPriceGlobal === true && checkVisitingCustomer == getVVIPParam) activeTier = 'vvip';
        if (showVIPPrivateSale === true && checkVIPUser === true && checkVisitingCustomerPrivateSale == getVIPParamPrivateSale) activeTier = 'vip';
        if (showVVIPPrivateSale === true && checkVVIPUser === true && checkVisitingCustomerPrivateSale == getVVIPParamPrivateSale) activeTier = 'vvip';

        var charmTotals = getCharmTotalsForMainItem(cartData.items, data, activeTier);
        if (charmTotals.regTotal > 0) {
          regPrice += charmTotals.regTotal;
          if (salePrice && salePrice > 0) salePrice += charmTotals.saleTotal;
          if (compareAtPrice && compareAtPrice > 0) compareAtPrice += charmTotals.regTotal;
        }

        var multiProdPrice = quantity*compareAtPrice;
        var multiProdSalePrice = quantity*salePrice;
        var formattedMultiProdPrice = multiProdPrice.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        formattedMultiProdPrice = formatPriceFunc(formattedMultiProdPrice); /* Remove decimal if .00 found in the price */
        var formattedMultiProdSalePrice = multiProdSalePrice.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        formattedMultiProdSalePrice = formatPriceFunc(formattedMultiProdSalePrice); /* Remove decimal if .00 found in the price */

        /* === Calculate Savings for this item === */
        var itemSavings = 0;
        if (salePrice && salePrice > 0 && regPrice > salePrice && !hideSavingTextCartMiniCart) {
          itemSavings = (regPrice - salePrice) * quantity;
        } else if (compareAtPrice && compareAtPrice > 0 && compareAtPrice > regPrice && !hideSavingTextCartMiniCart) {
          itemSavings = (compareAtPrice - regPrice) * quantity;
        }
        totalSavings += itemSavings;
  
        var percentageOff = ''
        if (showPercentOff == true) {
          percentageOff = (((regPrice - salePrice) / regPrice) * 100).toFixed(2)
          percentageOff = percentageOff.replace(/\.00$/, '') + "% Off";
        }
        if (compareAtPrice && compareAtPrice != null && compareAtPrice > 0 && compareAtPrice > regPrice && enableCompareAtPrice === true) {
          percentageOff = (((compareAtPrice - regPrice) / compareAtPrice) * 100).toFixed(2)
          percentageOff = percentageOff.replace(/\.00$/, '') + "% Off";
        }
        if ((salePrice != '' && salePrice > 0) || (compareAtPrice != null && compareAtPrice > 0)) {
          if (compareAtPrice && compareAtPrice > regPrice) {
            if (!window.matchMedia("(max-width: 767px)").matches){
              if ($("." + data.variant_id + data.properties._associated_unique_key + "_percentOff").length === 0 && $("." + data.variant_id + data.properties._associated_unique_key + "_compareAtPrice").length === 0) {
                $(".bcpo-cart-item-line-price" + data.variant_id + data.properties._associated_unique_key).after("<div class='alignItemCompareAt'><span class='cartCompareAt strikeThrough " + data.variant_id + data.properties._associated_unique_key + "_compareAtPrice'> " + "$" + formattedMultiProdPrice + "</span><span class='cartPercentOff " + data.variant_id + data.properties._associated_unique_key + "_percentOff' style='color:" + showPercentageOffColorGlobal + "'> " + percentageOff + "</span></div>");
                $("." + data.variant_id + data.properties._associated_unique_key + "_percentOff").eq(0).addClass("hto-cart-item-price");
                $("." + data.variant_id + data.properties._associated_unique_key + "_compareAtPrice").eq(0).addClass("hto-cart-item-price");
              }
            } else {
              $(".bcpo-cart-item-line-price"+data.variant_id + data.properties._associated_unique_key).after("<div class='alignItemCompareAt'><span class='cartCompareAt strikeThrough "+data.variant_id+data.properties._associated_unique_key+"_compareAtPrice'> " + "$"+ formattedMultiProdPrice + "</span><span class='cartPercentOff "+data.variant_id+data.properties._associated_unique_key+"_percentOff' style=display:block;line-height:8px;margin-top:4px;color:"+showPercentageOffColorGlobal+"> " +percentageOff + "</span></div>" );
            }
            $(".bcpo-cart-item-line-price"+data.variant_id + data.properties._associated_unique_key).parent().find("span.money").removeClass("strikeThrough").css("color",salePriceColorGlobal);
            $(".bcpo-cart-item-line-price"+data.variant_id + data.properties._associated_unique_key).parent().eq(1).addClass("textUpword-cart");
            $(".gift-card-"+data.variant_id).addClass("adjustUpwardHeightMobile");
          } else {
            if (salePrice && salePrice < regPrice) {
              $(".bcpo-cart-item-line-price" + data.variant_id + data.properties._associated_unique_key).html("$" + formattedMultiProdSalePrice).css("color", salePriceColorGlobal);
              if ($("." + data.variant_id + data.properties._associated_unique_key + "_percentOff").length === 0) {
                $(".bcpo-cart-item-line-price" + data.variant_id + data.properties._associated_unique_key).before("<span class='" + data.variant_id + data.properties._associated_unique_key + "_percentOff' style='color:" + showPercentageOffColorGlobal + "'> " + percentageOff + "</span><br>");
              }
              $(".bcpo-cart-item-line-price" + data.variant_id + data.properties._associated_unique_key).parent().find("span.money").eq(0).addClass("strikeThrough");
              if (!window.matchMedia("(max-width: 767px)").matches) {
                $("." + data.variant_id + data.properties._associated_unique_key+ "_percentOff").eq(0).addClass("hto-cart-item-price")
                $(".bcpo-cart-item-line-price" + data.variant_id + data.properties._associated_unique_key).parent().find("span.money").eq(1).addClass("strikeThrough");
              }
              $(".bcpo-cart-item-line-price" + data.variant_id + data.properties._associated_unique_key).parent().eq(1).removeClass("textUpword-cart");
              $(".gift-card-" + data.variant_id).removeClass("adjustUpwardHeightMobile");
            }
          }
        }
      }
    }
    /* === Append Total Savings in Cart === */
    if (totalSavings > 0) {
      var formattedSavings = totalSavings.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      formattedSavings = formatPriceFunc(formattedSavings); // use your formatting fn
      $("#appendTotalSavings").html("You are saving $" + formattedSavings);
    }
  }
}

/* Block SKU's to purchase */  
var skusToBlock = [
  "FJ9-508909", "FJ9-503436-BLA", "FJ11-502749-NA", "FJ9-501213", "FJ9-113455-14Y", "FJ9-13447-14Y",
  "FJ9-113445-14Y", "FJ9-113416-14Y-7", "FJ9-113295-14Y-PAIR", "FJ9-11339-1",
  "FJ9-11339-2", "FJ9-11339-3", "FJ11-RDF", "FJ9-12296-XS", "FJ9-12296-S", "FJ9-12296-M", "FJ9-12296-L",
  "FJ9-12296-XL", "FJ11-11740", "FJ9-517136", "FJ9-517135"
];

/* 
 This function will check all the items of the cart and match with the above SKUs array
 If it matches the condition then it will process to show popup on the screen to clear cart data
*/
function blockPurchaseforItems(grabCartItems) {
  var allItemsMatched = true;
  for (var i = 0; i < grabCartItems.items.length; i++) {
    if (!skusToBlock.includes(grabCartItems.items[i].sku)) {
      allItemsMatched = false;
      break; 
    }
  }
  if (allItemsMatched && grabCartItems.total_price === 0) {
    handleCheckoutButton();
  }
}

/* Hide/Show Popup */
function handleCheckoutButton() {
  var x = document.getElementById("block-single-purchase-popup");
  if(x === null) return
  if (x.style.display === "block") {
    x.style.display = "none";
  } else {
    x.style.display = "block";
  }
}

/* This function will clear complete cart data */
function clearCartData(){
  $.ajax({
    type: 'POST',
    url: '/cart/clear.js',
    dataType: 'json',
    success: function(data) {
      window.location.href = '/cart';
    },
    error: function(xhr, status, error) {
      console.error('Error clearing cart:', error);
    }
  });
}

/* ===== Charm totals for a main item: regular + active-tier sale (VIP/VVIP/global) ===== */
function getCharmTotalsForMainItem(cartItems, mainItem, activeTier) {
  // activeTier: 'sale' | 'vip' | 'vvip' | '' (none)
  var saleMap = window.__locketCharmSalePricesCart || {};
  var vipMap  = window.__locketCharmVipPricesCart  || {};
  var vvipMap = window.__locketCharmVvipPricesCart || {};
  var uniqueKey = mainItem.properties._associated_unique_key;
  var regTotal = 0;   // dollars
  var saleTotal = 0;  // dollars

  if (!uniqueKey) return { regTotal: 0, saleTotal: 0 };

  cartItems.forEach(function (item) {
    var props = item.properties || {};
    // Charm ghost identified by _stone_associated_variant_id, grouped by _associated_unique_key
    if (!props._stone_associated_variant_id) return;
    if (props._associated_unique_key !== uniqueKey) return;

    var charmReg = parseFloat(item.price) / 100;   // item.price is cents
    var qty = item.quantity || 1;
    regTotal += charmReg * qty;

    // Resolve this charm's active-tier price; fall back to its regular price
    var id = String(item.variant_id);
    var tierPrice = NaN;
    if (activeTier === 'vvip') tierPrice = parseFloat(vvipMap[id]);
    else if (activeTier === 'vip') tierPrice = parseFloat(vipMap[id]);
    else if (activeTier === 'sale') tierPrice = parseFloat(saleMap[id]);

    var charmSale = (isFinite(tierPrice) && tierPrice > 0) ? tierPrice : charmReg; // fallback to regular
    saleTotal += charmSale * qty;
  });

  return { regTotal: regTotal, saleTotal: saleTotal };
}